// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__uIEoR","item":"Menu_item__jfaZL","icon":"Menu_icon__YNNWA","active":"Menu_active__-0Z9R"};